const shelves = (state: any = [], action: any) => {
  switch (action.type) {
    case 'RECEIVE_SHELVES':
      return [...action.shelves];
    case 'CLEAN_SHELVES':
      return [];
    default:
      return shelfCourses(state, action);
  }
};

const shelfCourses = (state: any = [], action: any) => {
  switch (action.type) {
    case 'RECEIVE_SHELF_COURSES':
      return state.map((shelf: any) => {
        if (shelf.id === action.shelfId)
          return {
            ...shelf,
            courses: action.courses
          };
        return shelf;
      });
    default:
      return shelfLessons(state, action);
  }
};

const shelfLessons = (state: any = [], action: any) => {
  switch (action.type) {
    case 'RECEIVE_SHELF_LESSONS':
      return state.map((shelf: any) => {
        if (shelf.id === action.shelfId)
          return {
            ...shelf,
            lessons: action.lessons
          };
        return shelf;
      });
    default:
      return shelfOffers(state, action);
  }
};

const shelfOffers = (state: any = [], action: any) => {
  switch (action.type) {
    case 'RECEIVE_SHELF_OFFERS':
      return state.map((shelf: any) => {
        if (shelf.type === 'offer')
          return {
            ...shelf,
            offers: action.offers
          };
        return shelf;
      });
    default:
      return shelfSchools(state, action);
  }
};

const shelfSchools = (state: any = [], action: any) => {
  switch (action.type) {
    case 'RECEIVE_SHELF_SCHOOLS':
      return state.map((shelf: any) => {
        if (shelf.type === 'school')
          return {
            ...shelf,
            schools: action.schools
          };
        return shelf;
      });
    default:
      return state;
  }
};

export default shelves;
